<template>
  <div class="w-full bg-slate-50 min-h-screen p-4 md:p-8" style="font-family: 'Inter', sans-serif;">
    <div class="max-w-7xl mx-auto space-y-8">
      
      <!-- HEADER -->
      <div class="mb-8">
        <h1 class="text-2xl font-black text-slate-800 tracking-tight">Relatório Analítico</h1>
        <p class="text-sm text-slate-500 font-medium mt-1">Gere relatórios analíticos do almoxarifado</p>
      </div>

      <!-- FORMULÁRIO -->
      <section class="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm">
          <div class="px-6 py-4 flex items-center gap-3" style="background-color: #333333;">
              <v-icon color="orange" small>mdi-chart-line</v-icon>
              <h2 class="text-white font-bold uppercase tracking-widest text-[11px]">
                  PARÂMETROS DO RELATÓRIO
              </h2>
          </div>
          <div class="p-8">
              <v-row dense>
                  <v-col cols="12" sm="12" md="3">
                    <label class="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2">Data Inicial</label>
                    <Date @dateValue="[(itemNewValues.startDate = $event)]" label="Data Inicial" />
                  </v-col>
                  <v-col cols="12" sm="12" md="3">
                    <label class="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2">Data Final</label>
                    <Date @dateValue="[(itemNewValues.endDate = $event)]" label="Data Final" />
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <label class="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2">Prefeitura</label>
                    <v-autocomplete
                      v-model="itemNewValues.prefecture_id"
                      :items="prefectures"
                      item-text="prefecture_social_name"
                      item-value="prefecture_id"
                      clearable outlined dense hide-details="auto"
                      class="bg-slate-50"
                      :readonly="formDisable"
                      placeholder="Selecione a prefeitura"
                    />
                  </v-col>
              </v-row>

              <div class="flex justify-end mt-8">
                  <button
                    @click="itemNewValues.prefecture_id && itemNewValues.startDate && itemNewValues.endDate ? generateReport() : null"
                    :disabled="!(itemNewValues.prefecture_id && itemNewValues.startDate && itemNewValues.endDate)"
                    class="bg-orange-500 hover:bg-orange-600 text-white rounded-lg shadow-md shadow-orange-500/20 px-8 h-12 transition-all transform hover:-translate-y-0.5 flex items-center justify-center gap-2 text-[11px] font-black uppercase tracking-widest disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                      <v-icon color="white" small class="mr-1">mdi-file-document-outline</v-icon>
                      Gerar Relatório
                  </button>
              </div>
          </div>
      </section>

      <v-snackbar
        multi-line
        :color="snack.color"
        v-model="snack.show"
        transition="fade-transition"
        top
        right
      >
        {{ snack.message }}
        <template v-slot:action="{ attrs }">
          <v-btn dark text v-bind="attrs" @click="snack.show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
      </v-snackbar>
    </div>
  </div>
</template>

<script>
import Date from "@/components/InputDate.vue";
import Helpers from "@/mixins/helpers";
export default {
  components: { Date },
  mixins: [Helpers],
  data: () => ({
    prefectures: [],
    itemNewValues: {
      prefecture_id: null,
      startDate: null,
      endDate: null,
    },
    loader: false,
    snack: {
      show: false,
      message: "",
      color: "",
    },
    formDisable: false,
  }),
  created() {
    this.Helpers;
    this.loader = true;
    this.$store.dispatch("setLoader", this.loader);
    this.$http.get(`/prefectures`).then((r) => {
      this.prefectures = r.data;
      this.loader = false;
      this.$store.dispatch("setLoader", this.loader);
    });
    if (this.$store.getters.getUserData.table_key == 'prefectures') {
      this.formDisable = true;
      this.itemNewValues.prefecture_id = this.$store.getters.getUserData.table_id;
    }
  },
  methods: {
    emptyValues() {
      this.itemNewValues.prefecture_id = null;
      this.itemNewValues.startDate = null;
      this.itemNewValues.endDate = null;
    },
    generateReport() {
      const url = `${window.origin}/#/parts-and-services/report/analytical/${this.itemNewValues.prefecture_id}/${this.itemNewValues.startDate}/${this.itemNewValues.endDate}`;
      window.open(url, '_blank');
    },
  },
};
</script>

<style>
</style>